/**
 * 按钮权限
 */
import store from '../store'

export default {
    install(Vue) {
        Vue.prototype.btn = function (d) {
            let b = sessionStorage.getItem("permission").indexOf(d)
            return b >= 0
        }
    }
}